import {createSelector} from '@reduxjs/toolkit';

import {isChannelsChannelCategory} from '../utils/isChannelsChannelCategory';

import {getAllChannelCategoriesByIds} from './get_all_channel_categories_by_ids';

export const getChannelsChannelCategories = createSelector(getAllChannelCategoriesByIds, (categories) => {
    return Object.values(categories).filter(isChannelsChannelCategory);
});
